import React from 'react';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Package, ShoppingBag, Users, Grid,
  Star, BarChart3, Settings, LogOut, ChevronLeft, ChevronRight, X,
} from 'lucide-react';
import DynamicLogo from './DynamicLogo';

const Sidebar = ({ collapsed, mobileOpen, onToggle, onClose, isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/customers', icon: Users, label: 'Customers' },
    { path: '/categories', icon: Grid, label: 'Categories' },
    { path: '/products', icon: Package, label: 'Products' },
    { path: '/orders', icon: ShoppingBag, label: 'Orders' },
    { path: '/reviews', icon: Star, label: 'Reviews' },
    { path: '/reports', icon: BarChart3, label: 'Reports' },
    { path: '/banners', icon: BarChart3, label: 'Banners' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('rememberMe');
    sessionStorage.clear();
    if (isMobile) onClose();
    navigate('/login', { replace: true });
  };

  return (
    <>
      {mobileOpen && isMobile && (
        <div className="sidebar-overlay" onClick={onClose} />
      )}

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            {/* ✅ Dynamic Logo */}
            <DynamicLogo
              size={collapsed && !isMobile ? 'sm' : 'md'}
              showText={!collapsed || isMobile}
              textColor="#fff"
            />
          </div>

          {!isMobile && (
            <button className="sidebar-toggle desktop-toggle" onClick={onToggle} aria-label="Toggle sidebar">
              {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
            </button>
          )}

          {isMobile && mobileOpen && (
            <button className="sidebar-toggle mobile-close" onClick={onClose} aria-label="Close sidebar">
              <X size={24} />
            </button>
          )}
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              (item.path !== '/' && location.pathname.startsWith(item.path));
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={`sidebar-link ${isActive ? 'active' : ''}`}
                onClick={() => { if (isMobile) onClose(); }}
              >
                <item.icon size={20} />
                {(!collapsed || isMobile) && <span>{item.label}</span>}
                {isActive && !collapsed && !isMobile && (
                  <span className="sidebar-badge">Active</span>
                )}
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-link logout-link" onClick={handleLogout}>
            <LogOut size={20} />
            {(!collapsed || isMobile) && <span>Logout</span>}
          </button>

          {!isMobile && !collapsed && (
            <div className="sidebar-version">v2.0.0</div>
          )}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;